import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { getStorage } from '../core/utilities';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';

import { BaseComponents } from '../base.component';

@Injectable()
export class InsuranceNotifyService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient, 
    public wpTokenService: WpTokenService
  ) { 
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any, ref: any = '') {
    //const url = `${environment.endpointBackend}/api/insurance/notify`;
    const url = `${environment.endpointBackend}/api/services/buy-insurance/notify?ref=${ref}`;
    const reference = ref || param?.referenceID;
    const body = withBuyonlineAccessToken(reference, this.input(param));
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(param: any, ref: any = '') {
    const self = this;
    const utm_params = getStorage('utm_params');
    if (utm_params) {
      param = {
        ...param,
        ...utm_params
      }
    }
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(param,ref).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            let re = res['body'];
            //console.log('InsuranceNotifyService',re)
            if (re.status && re.data) {
              resolve(self.output(re.data));
            } else {
              resolve(self.output(re));
            }
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        });
      }
    });
  }
}
